module.exports = __webpack_public_path__ + "live.f1fdaa91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/live.svg
// module id = 200
// module chunks = 0